import React from "react";

const base = (size, extra = {}) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  ...extra,
});

export const IconResults = ({ size = 16 }) => (
  <svg {...base(size)}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M9 21V9" />
  </svg>
);
export const IconPortfolio = ({ size = 16 }) => (
  <svg {...base(size)}>
    <path d="M21 12a9 9 0 1 1-9-9" />
    <path d="M12 3v9h9" />
  </svg>
);
export const IconBacktest = ({ size = 16 }) => (
  <svg {...base(size)}>
    <path d="M3 20h18M5 20V10M10 20V4M15 20v-8M20 20V7" />
  </svg>
);
export const IconLogs = ({ size = 16 }) => (
  <svg {...base(size)}>
    <path d="M4 6h16M4 12h10M4 18h14" />
  </svg>
);
export const IconSettings = ({ size = 16 }) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1" />
  </svg>
);
export const IconDownload = ({ size = 14 }) => (
  <svg {...base(size)}>
    <path d="M12 3v12m0 0l-4-4m4 4l4-4M4 17v3h16v-3" />
  </svg>
);
export const IconRefresh = ({ size = 14 }) => (
  <svg {...base(size)}>
    <path d="M21 12a9 9 0 1 1-3-6.7M21 3v6h-6" />
  </svg>
);
export const IconSearch = ({ size = 14 }) => (
  <svg {...base(size, { stroke: "var(--muted)" })}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
);
export const IconLink = ({ size = 14 }) => (
  <svg {...base(size)}>
    <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" />
    <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
  </svg>
);
export const IconCopy = ({ size = 14 }) => (
  <svg {...base(size)}>
    <rect x="9" y="9" width="12" height="12" rx="2" />
    <path d="M5 15V5h10" />
  </svg>
);
export const IconCheck = ({ size = 14 }) => (
  <svg {...base(size, { strokeWidth: 2.5 })}>
    <path d="M5 12l5 5L20 7" />
  </svg>
);
export const IconQuality = ({ size = 20 }) => (
  <svg {...base(size)}>
    <path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z" />
  </svg>
);
export const IconFair = ({ size = 20 }) => (
  <svg {...base(size)}>
    <path d="M3 17l5-6 4 3 5-7 4 4" />
    <path d="M3 21h18" strokeDasharray="3 3" />
  </svg>
);
export const IconRank = ({ size = 20 }) => (
  <svg {...base(size)}>
    <path d="M4 6h16M4 12h10M4 18h6" />
    <path d="M18 10v8M15 15l3 3 3-3" />
  </svg>
);
export const IconSignOut = ({ size = 14 }) => (
  <svg {...base(size)}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </svg>
);
export const IconArrow = ({ size = 14 }) => (
  <svg {...base(size)}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);
